module.exports = __webpack_public_path__ + "img/gl.035b8513.svg";